/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedLetterG = createReactComponent(
  "square-rounded-letter-g",
  "IconSquareRoundedLetterG",
  [
    [
      "path",
      { d: "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", key: "svg-0" }
    ],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareRoundedLetterG as default };
//# sourceMappingURL=IconSquareRoundedLetterG.js.map
